var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('md-button',{staticClass:"md-button md-accent",on:{"click":function($event){_vm.clearCache()}}},[_c('md-icon',[_vm._v("clear")]),_vm._v("Clear Offline Cache\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }